module.exports = __webpack_public_path__ + "img/ep-Q.640bf72d.jpg";